import { createContext, useState } from 'react';
import { wrap } from '@hilma/tools';

export const FreeSaleLinkContext = createContext<[string | null, React.Dispatch<React.SetStateAction<string | null>>] | null>(null);
export const IsFreeSaleContext = createContext<[boolean | null, React.Dispatch<React.SetStateAction<boolean | null>>] | null>(null);

const FreeSaleProvider: React.FC = ({ children }) => {
	const freeSaleLinkTuple = useState<string | null>(null);
	const isFreeSaleTuple = useState<boolean | null>(null);

	return wrap(
		[FreeSaleLinkContext.Provider, { value: freeSaleLinkTuple }],
		[IsFreeSaleContext.Provider, { value: isFreeSaleTuple }]
	)(children) as React.ReactElement;
}

export default FreeSaleProvider;